import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/reportesbi/reportes/Ver/{id}',
  documento: 'reportesbi',
  acceso: 'sesion',
  filas: ['116'],
  cita: 'Areas/ReportesBI/Controllers/ReportesController.cs:72',
} satisfies RutaProd;
